import React from 'react'

const TableData = ({title}) => {
  return (
    <td className='p-2  text-center '>
      {title}
    </td>
  )
}

export default TableData
